import { DeliveryProvider } from '../../../../services/exports/Constants';

export default {
  [DeliveryProvider.Standalone]: 'Ravintolan oma kuljettajafilo',
  [DeliveryProvider.UberDrive]: 'Uber-kuljetus',
  [DeliveryProvider.WoltDrive]: 'Wolt-kuljetus',
};
